export default __webpack_public_path__ + "static/media/suit-3.0106eefb.jpg";